export const onlyText = (value: string) => {
  return value.replace(/\d/g, '')
}
